import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { AccordionPanelCard } from './AccordionPanel.Card.es.js';
import { AccordionPanelContent } from './AccordionPanel.Content/AccordionPanelContent.es.js';
import { AccordionPanelProvider } from './AccordionPanel.Context/provider.es.js';
import { AccordionPanelGroup } from './AccordionPanel.Group/AccordionPanelGroup.es.js';
import { AccordionPanelHeader } from './AccordionPanel.Header/AccordionPanelHeader.es.js';

const AccordionPanel = ({ size = 'sm', onCard = true, open = false, inlineInfo, className, children, ...props })=>{
    return jsx(AccordionPanelProvider, {
        inlineInfo: inlineInfo,
        onCard: onCard,
        open: open,
        size: size,
        children: jsx("div", {
            className: classNames('cb-accordion-panel', className),
            ...props,
            "data-testid": "accordion-panel",
            children: jsx(AccordionPanelCard, {
                children: children
            })
        })
    });
};
AccordionPanel.displayName = 'AccordionPanel';
AccordionPanel.Header = AccordionPanelHeader;
AccordionPanel.Content = AccordionPanelContent;
AccordionPanel.Group = AccordionPanelGroup;

export { AccordionPanel, AccordionPanel as default };
//# sourceMappingURL=AccordionPanel.es.js.map
